var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-fullscreen-loader',
    {
      'dp-fullscreen-loader--active': _vm.active,
    }
  ]},[(_vm.$slots.default)?_c('div',{staticClass:"dp-fullscreen-loader__inner"},[_vm._t("default")],2):_vm._e(),(!_vm.$slots.default)?_c('dp-circle-loader',{staticClass:"dp-fullscreen-loader__default-spinner"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }